import { jsx } from "react/jsx-runtime";
import classnames from "../../utils/classnames.js";
import Tag from "../Tag/Tag.js";
import Tooltip from "../Tooltip/Tooltip.js";
import Typography from "../Typography/Typography.js";
import './DealerDetails.css';/* empty css                   */
const DealerDetails = ({
  className,
  tooltipTitle,
  iconPosition = "left",
  closable = false,
  ...props
}) => {
  const hasTooltip = !!tooltipTitle;
  return /* @__PURE__ */ jsx(
    "div",
    {
      tabIndex: 0,
      role: "button",
      onClick: hasTooltip ? (e) => e.stopPropagation() : void 0,
      onKeyDown: hasTooltip ? (e) => e.stopPropagation() : void 0,
      children: /* @__PURE__ */ jsx(
        Tooltip,
        {
          destroyTooltipOnHide: true,
          title: hasTooltip ? /* @__PURE__ */ jsx(Typography.Text, { level: "small", color: "darkest", children: typeof tooltipTitle === "string" ? /* @__PURE__ */ jsx("span", { dangerouslySetInnerHTML: { __html: tooltipTitle } }) : tooltipTitle }) : null,
          placement: "top",
          className: classnames("perxis-auto-dealer-details-tooltip"),
          buttonClassName: classnames("perxis-auto-dealer-details-tooltip-button"),
          children: /* @__PURE__ */ jsx(
            Tag,
            {
              ...props,
              closable,
              iconPosition,
              className: classnames("perxis-auto-dealer-details", className)
            }
          )
        }
      )
    }
  );
};
export {
  DealerDetails as default
};
//# sourceMappingURL=DealerDetails.js.map
